import { render, staticRenderFns } from "./GroupsSicuroCentralUnit.vue?vue&type=template&id=8037b1ce&"
import script from "./GroupsSicuroCentralUnit.vue?vue&type=script&lang=js&"
export * from "./GroupsSicuroCentralUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports